<app-header></app-header>
<main class="portal-main-content">
  <router-outlet></router-outlet>
</main>
<app-footer *ngIf="showFooter"></app-footer>